export default "__VITE_ASSET__daa8c7aa__"